// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_CUTTING_DC_REQUEST = 'FETCH_CUTTING_DC_REQUEST';
export const FETCH_CUTTING_DC_SUCCESS = 'FETCH_CUTTING_DC_SUCCESS';
export const FETCH_CUTTING_DC_FAILURE = 'FETCH_CUTTING_DC_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_CUTTING_DC_STYLE_REQUEST = 'FETCH_CUTTING_DC_STYLE_REQUEST';
export const FETCH_CUTTING_DC_STYLE_SUCCESS = 'FETCH_CUTTING_DC_STYLE_SUCCESS';
export const FETCH_CUTTING_DC_STYLE_FAILURE = 'FETCH_CUTTING_DC_STYLE_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_CUTTING_DC_FORMAT_REQUEST = 'FETCH_CUTTING_DC_FORMAT_REQUEST';
export const FETCH_CUTTING_DC_FORMAT_SUCCESS = 'FETCH_CUTTING_DC_FORMAT_SUCCESS';
export const FETCH_CUTTING_DC_FORMAT_FAILURE = 'FETCH_CUTTING_DC_FORMAT_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_CUTTING_DC_REQUEST = 'CREATE_CUTTING_DC_REQUEST';
export const CREATE_CUTTING_DC_SUCCESS = 'CREATE_CUTTING_DC_SUCCESS';
export const CREATE_CUTTING_DC_FAILURE = 'CREATE_CUTTING_DC_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_CUTTING_DC = 'CREATE_USER_FORM_CUTTING_DC';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_CUTTING_DC_REQUEST = 'UPDATE_CUTTING_DC_REQUEST';
export const UPDATE_CUTTING_DC_SUCCESS = 'UPDATE_CUTTING_DC_SUCCESS';
export const UPDATE_CUTTING_DC_FAILURE = 'UPDATE_CUTTING_DC_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_CUTTING_DC_REQUEST = 'FETCH_SINGLE_CUTTING_DC_REQUEST';
export const FETCH_SINGLE_CUTTING_DC_SUCCESS = 'FETCH_SINGLE_CUTTING_DC_SUCCESS';
export const FETCH_SINGLE_CUTTING_DC_FAILURE = 'FETCH_SINGLE_CUTTING_DC_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_CUTTING_DC_REQUEST = 'DELETE_CUTTING_DC_REQUEST';
export const DELETE_CUTTING_DC_SUCCESS = 'DELETE_CUTTING_DC_SUCCESS';
export const DELETE_CUTTING_DC_FAILURE = 'DELETE_CUTTING_DC_FAILURE';

// USERFORM RESET

export const CUTTING_DC_USERFORM_RESET = 'CUTTING_DC_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_CUTTING_DC_DETAILS = 'NAVIGATE_CUTTING_DC_DETAILS';
// navigate to company component
export const NAVIGATE_CUTTING_DC = 'NAVIGATE_CUTTING_DC';
export const CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB = 'CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB';
export const CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE = 'CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_REVERSE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_CUTTING_DC_INVOICE_REQUEST = 'FETCH_CUTTING_DC_INVOICE_REQUEST';
export const FETCH_CUTTING_DC_INVOICE_SUCCESS = 'FETCH_CUTTING_DC_INVOICE_SUCCESS';
export const FETCH_CUTTING_DC_INVOICE_FAILURE = 'FETCH_CUTTING_DC_INVOICE_FAILURE';

export const RESET_CUTTING_DC_INVOICE_V2 = 'RESET_CUTTING_DC_INVOICE_V2';


export const FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_REQUEST = 'FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_REQUEST';
export const FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_SUCCESS = 'FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_SUCCESS';
export const FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_FAILURE = 'FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_FAILURE';




export const CLOSE_BTN_POST_REQUEST_CUTTING = 'CLOSE_BTN_POST_REQUEST_CUTTING'
export const CLOSE_BTN_POST_SUCCESS_CUTTING = 'CLOSE_BTN_POST_SUCCESS_CUTTING'
export const CLOSE_BTN_POST_FAILURE_CUTTING = 'CLOSE_BTN_POST_FAILURE_CUTTING'



export const DELETE_CUTTING_DC_REQUEST_CALL_OFF = 'DELETE_CUTTING_DC_REQUEST_CALL_OFF'
export const DELETE_CUTTING_DC_SUCCESS_CALL_OFF = 'DELETE_CUTTING_DC_SUCCESS_CALL_OFF'
export const DELETE_CUTTING_DC_FAILURE_CALL_OFF = 'DELETE_CUTTING_DC_FAILURE_CALL_OFF'


export const CUTTING_DC_REQUEST_RETURN_QTY = 'CUTTING_DC_REQUEST_RETURN_QTY'
export const DELETE_CUTTING_DC_SUCCESS_RETURN_QTY = 'DELETE_CUTTING_DC_SUCCESS_RETURN_QTY'
export const DELETE_CUTTING_DC_FAILURE_RETURN_QTY = 'DELETE_CUTTING_DC_FAILURE_RETURN_QTY'


export const FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_SUCCESS_RESET = 'FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_SUCCESS_RESET';

export const HEADER_SEARCH_CALL_ONLOAD = 'HEADER_SEARCH_CALL_ONLOAD';

export const NAVIGATE_CUTTING_DC_PRINT = 'NAVIGATE_CUTTING_DC_PRINT';

// export const SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_CUTTING_INWARD = 'SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_CUTTING_INWARD'




